module.exports = __webpack_public_path__ + "media/test3.59485a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/test3.png
// module id = 679
// module chunks = 2